import { SECTIONS } from '@/types/sections'

export function useNodeSection() {
  const { t } = useI18n()

  function getNodeSectionTranslation(sectionName: string) {
    switch (sectionName) {
      case SECTIONS.QUEUE:
      case SECTIONS.INBOX:
        return t('box_details.navigation.inbox')
      case SECTIONS.FILES:
        return t('box_details.navigation.files')
      case SECTIONS.TRASH:
        return t('box_details.navigation.trash')
      default:
        return sectionName
    }
  }

  function getNodeSectionTranslationByRouteName(routeName: string) {
    if (routeName === 'organization-types-type-boxes-box-files') {
      return t('box_details.navigation.files')
    }
    if (routeName === 'organization-types-type-boxes-box-inbox') {
      return t('box_details.navigation.inbox')
    }
    if (routeName === 'organization-types-type-boxes-box-trash') {
      return t('box_details.navigation.trash')
    }
    if (routeName.includes('search')) {
      return t('page_titles.search_results')
    }
    return ''
  }

  function getNodeSectionIcon(sectionName: string) {
    switch (sectionName) {
      case SECTIONS.QUEUE:
      case SECTIONS.INBOX:
        return 'far fa-envelope'
      case SECTIONS.FILES:
        return 'far fa-folder'
      case SECTIONS.TRASH:
        return 'far fa-trash'
      default:
        return 'far fa-folder'
    }
  }

  return {
    getNodeSectionTranslation,
    getNodeSectionTranslationByRouteName,
    getNodeSectionIcon,
  }
}
